import config from "@Config/index";
import type { RegionalBlogLanguage } from "./blogLanguage";

const isBlogRevampEnabled = (lang?: RegionalBlogLanguage): boolean =>
  !lang && !config.IS_CHINA_APP && !config.IS_WHITELABEL_APP;

export default isBlogRevampEnabled;
